//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { LMap, LTileLayer, LMarker, LPopup, LControl, LControlZoom } from "vue2-leaflet"
import Vue2LeafletMarkercluster from 'vue2-leaflet-markercluster';
import * as L from 'leaflet'

import { Icon } from 'leaflet';
require("leaflet-sidebar");

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('../../images/mapicon.png'),
  iconUrl: require('../../images/mapicon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
  iconSize: [71, 78],
  iconAnchor: [35, 78],
});

export default {
      props: ['items', 'categories', 'zoom', 'latitude', 'longitude'],
      components: {
        'L': L,
        'l-map': LMap,
        'l-control': LControl,
        'l-control-zoom': LControlZoom,
        'v-tilelayer': LTileLayer,
        'v-marker': LMarker,
        'v-popup': LPopup,
        'v-marker-cluster': Vue2LeafletMarkercluster,
      },
      data: (instance) => ({
        map: null,
        isMobile: true,
        map_height: '765',
        mapInfo:{
          zoom: instance.zoom,
          center: instance.pos(instance.latitude, instance.longitude),
          url: 'https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png',
          attribution: 'Aramendia &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
          clusterOptions: {
            maxClusterRadius: 80,
          },
          listControl: null,
        },   
      }),
      methods:{
        pos(lat, long)
        {
          return L.latLng(parseFloat(lat), parseFloat(long));
        },
        centerItem(id)
        { 
          let marker = this.$refs['mark'+id][0].mapObject;            
          let markerBounds = L.latLngBounds([ marker.getLatLng() ]);
          this.map.fitBounds(markerBounds, {maxZoom: 17, animate: true});
          if(this.isMobile) {  
            let diff = screen.height - $('#mapa').first().height();
            
            $([document.documentElement, document.body]).animate({
                scrollTop: $("#mapa").offset().top - diff
            }, 500);       
          }
          
          setTimeout(function(){ marker.openPopup(); }, 500);
        }
      },
      mounted(){
        this.$nextTick(() => {
          this.map = this.$refs.map.mapObject;
          
          if(!L.Browser.mobile)
          {
            this.isMobile = false;
            this.mapInfo.listControl = L.control.sidebar('list-control',{
                autoPan: true,
                closeButton: false,
                position: 'left',
            }).addTo(this.map);
            this.mapInfo.listControl.show();
          }

          if(L.Browser.mobile)
          {
            this.map_height = '350';
          }
        });
      }
}



// WEBPACK FOOTER //
// ./scripts/vue/mapa.vue